import { render, staticRenderFns } from "./EModalBoletimFranquia.vue?vue&type=template&id=dfbcfcc8&scoped=true"
import script from "./EModalBoletimFranquia.vue?vue&type=script&lang=js"
export * from "./EModalBoletimFranquia.vue?vue&type=script&lang=js"
import style0 from "./EModalBoletimFranquia.vue?vue&type=style&index=0&id=dfbcfcc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbcfcc8",
  null
  
)

export default component.exports